import React from "react";
import stylesForOferta from "./stylesForOferta.module.css";
import Logo from "./icons/logo";
import SEO from "../components/seo";

const Oferta = () => {
  return (
    <>
      <SEO title="Оферта курсов по web3-разработке: Solidity, NFT, DAO, DeFi" />
      <div className={stylesForOferta.container}>
        <div className={stylesForOferta.logo}>
          <Logo />
        </div>
        <p>10.01.2022</p>
        <p className={stylesForOferta.title}>
          Публичная оферта на оказание информационно-консультационных услуг
        </p>{" "}
        <p>1. ОБЩИЕ ПОЛОЖЕНИЯ</p>{" "}
        <p>
          1.1. Настоящий публичный договор (далее — Оферта) представляет собой
          официальное предложение ООО "МОСКОУ КОДИНГ СКУЛ" (ИНН 7725262648, ОГРН
          1157746115438), в лице генерального директора Резвого Вадима
          Викторовича, далее именуемого «Исполнитель», по оказанию
          информационных-консультационных услуг юридическим и/или дееспособным
          физическим лицам на перечисленных ниже условиях в форме онлайн-курсов
          — специальной формы, направленной на приобретение Заказчиком
          информации, умений и навыков в определенной сфере деятельности в
          результате потребления контента Курса.
        </p>{" "}
        <p>
          Полным и безоговорочным акцептом настоящей оферты является
          осуществление Заказчиком оплаты предложенных Исполнителем Услуг
          (полностью или частично).
        </p>{" "}
        <p>
          1.2. В соответствии с пунктом 2 статьи 437 Гражданского кодекса
          Российской Федерации (далее — ГК РФ) данный документ является
          публичной Офертой, и в случае принятия изложенных ниже условий и
          оплаты услуг Исполнителя, лицо, осуществившее Акцепт настоящей Оферты,
          становится Заказчиком (в соответствии с пунктом 3 статьи 438 ГК РФ
          акцепт Оферты равносилен заключению договора на условиях, изложенных в
          Оферте, что безоговорочно принимается сторонами).
        </p>{" "}
        <p>
          1.3. Исполнитель и Заказчик предоставляют взаимные гарантии своей
          право- и дееспособности, необходимые для заключения и исполнения
          настоящего Договора на оказание информационных услуг.
        </p>{" "}
        <p>2. ОПРЕДЕЛЕНИЯ И ТЕРМИНЫ</p>{" "}
        <p>
          2.1. В целях единого понимания настоящей Оферты нижеприведенные
          термины используются в следующем значении: Оферта — настоящий
          публичный договор на оказание информационно-консультационных услуг.
          Сайт — интернет-сайт: https://guidedao.xyz/ используемый Исполнителем
          для оказания услуг Заказчикам и предоставления информации.
          Информационно-консультационные услуги — услуги Исполнителя по
          предоставлению ограниченного доступа Заказчика к Сайту в соответствии
          с условиями Оферты и наполнением выбранного тарифа к специальным
          материалам (в том числе с помощью рассылок), либо консультационных
          услуг в иной форме. Форма и необходимость предоставления сопутствующих
          информационных услуг определяются Исполнителем самостоятельно и
          размещается на Сайте https://www.guidedao.xyz/. Акцепт Оферты — полное
          и безоговорочное принятие Оферты путем осуществления действий по
          предварительной оплате Информационной услуги в размере 100%.
          Исполнитель — ООО "МОСКОУ КОДИНГ СКУЛ" предоставляющий
          информационно-консультационные услуги Заказчику на условиях настоящей
          Оферты. Заказчик — лицо, осуществившее Акцепт Оферты на изложенных в
          ней условиях. Договор на оказание информационно-консультационных услуг
          (далее — Договор) — договор между Заказчиком и Исполнителем на
          предоставление информационно-консультационных услуг, который
          заключается посредством Акцепта настоящей Оферты. Курс/Буткемп -
          совокупность услуг по предоставлению доступа к видеоурокам и онлайн
          сессиям, оказываемых в соответствии с Тарифом при помощи сети
          Интернет, объединенных единой тематикой и направленные на
          самостоятельное приобретение Заказчиком знаний и навыков по
          соответствующей теме. Все материалы, входящие в состав Курса являются
          произведениями в смысле ст. 1259 ГК РФ. Тариф курса/буткемпа - пакет
          услуг Исполнителя в рамках выбранного Заказчиком Курса. Тариф
          публикуется Исполнителем на Сайте.
        </p>{" "}
        <p>3. ПРЕДМЕТ ОФЕРТЫ</p>{" "}
        <p>
          3.1. Предметом настоящей Оферты является возмездное оказание Заказчику
          силами Исполнителя Услуг по проведению буткемпов/курсов (тренингов),
          расположенных на сайте https://www.guidedao.xyz/ в форме видеозаписей,
          онлайн сессий и консультационных мероприятий по сети Интернет через
          предоставление специального доступа, в порядке и сроки,
          предусмотренные настоящей офертой (ознакомиться можно по ссылке
          https://www.guidedao.xyz/) (далее – услуги). 3.2. Стоимость услуг
          устанавливается на Сайте Исполнителя. Договор на оказание
          информационно-консультационных услуг считается заключенным с момента
          поступления денежных средств на расчетный счет Исполнителя. 3.3. Курс
          не является профессиональным обучением по смыслу Федерального закона
          от 29.12.2012 N 273-ФЗ «Об образовании в Российской Федерации».
          Участие в проводимом курсе не сопровождается итоговой аттестацией
          и/или выдачей документов об образовании и/или квалификации в
          соответствии с государственными стандартами обучения, действующими на
          территории Российской Федерации.
        </p>{" "}
        <p>4. УСЛОВИЯ ОКАЗАНИЯ УСЛУГ</p>{" "}
        <p>
          4.1. Исполнитель предоставляет доступ Заказчику к материалам
          оплаченных услуг, размещенным на Сайте (с помощью личного кабинета),
          при условии 100% предоплаты этой услуги.
        </p>{" "}
        <p>
          4.2. Заказчик осуществляет 100% оплату услуг, в сумме согласно
          выбранному Тарифу на сайте, минимум за сутки до старта оплаченных
          услуг или тренинга.
        </p>{" "}
        <p>
          4.3. Стоимость услуг, а также способы оплаты услуг указываются
          Исполнителем на Сайте.
        </p>{" "}
        <p>
          4.4. Датой оплаты считается дата зачисления денежных средств на
          расчетный счет Исполнителя.
        </p>
        <p>
          4.5. Участие в курсе (использование Услуги) подтверждается заполнением
          соответствующей заявки на участие и внесением оплаты одним из
          способов, указанных на Сайте. Ссылки и Приглашения предоставляются
          Заказчику путем их направления на адрес электронной почты или в
          мессенджер, привязанный к мобильному телефону Заказчика, указанный им
          при заполнении заявки на участие. При оплате услуг третьим лицом, в
          частности юридическим лицом, следует обращаться непосредственно к
          Исполнителю для заключения соответствующего счета-договора в бумажном
          виде.
        </p>
        <p>
          4.6. Услуга по предоставлению доступа к видео урокам и онлайн сессиям,
          входящим в состав Курса считается оказанной с момента предоставления
          такого доступа Заказчику.
        </p>
        <p>
          4.7. Услуга по проверке домашних заданий считается оказанной в полном
          объеме и в том случае, когда домашние задания не высылались Заказчиком
          на проверку.
        </p>
        <p>
          4.8. Отсутствие претензий со стороны Заказчика, направленных в
          письменной форме в адрес Исполнителя, в течение трех календарных дней
          со дня оказания услуги является подтверждением того, что оказанные
          услуги приняты Заказчиком без замечаний.
        </p>
        <p>
          4.9. Если в установленное время Заказчик не подключается к
          онлайн-трансляции и не предупредил об этом минимум за трое суток до
          начала оказания Услуг, Услуга считается оказанной и не переносится на
          другое время.
        </p>
        <p>
          4.10. Настоящий договор имеет силу акта об оказании услуг. Приемка
          производится без подписания соответствующего акта. Услуги считаются
          оказанными надлежащим образом и принятыми Заказчиком в полном объеме,
          если в течение трех дней по истечении срока оказания услуг Исполнитель
          не получил от Заказчика мотивированных письменных возражений по
          качеству оказанных услуг на электронную почту yo@guidedao.xyz. В любом
          случае, отсутствие любых письменных замечаний в течение установленного
          срока считается признанием факта надлежащего качества услуг.
        </p>
        <p>
          4.11. Исполнитель оставляет за собой право аннулировать участие
          Заказчика в Курсе без возвращения внесенной платы в случае нарушения
          им правил поведения на тренинге (указанными нарушениями являются:
          разжигание межнациональных конфликтов, оскорбление участников Курса
          или спикера, отклонение от темы Курса, реклама, нецензурные
          высказывания), а также за нарушение законодательства РФ.
        </p>
        <p>
          4.12. Исполнитель оставляет за собой право аннулировать участие
          Заказчика в тренинге без возврата денежных средств в случае
          установления факта передачи им реквизитов для участия в Курсе третьим
          лицам, распространения Заказчиком информации и материалов, полученных
          им в связи с участием в тренинге, третьим лицам за плату.
        </p>
        <p>
          4.13. В случае неоплаты стоимости Услуг в установленные сроки, при
          несвоевременном предоставлении данных для оформления заявки, либо при
          указании недостоверных данных при оформлении заявки настоящий Договор
          не считается заключенным.{" "}
        </p>
        <p>
          4.14. Акцептуя условия Договора, Заказчик дает согласие в соответствии
          с действующим законодательством на обработку (далее Обработка ПД)
          Исполнителем предоставленной им информации и (или) его персональных
          данных. Обработка персональных данных совершается с использованием
          средств автоматизации или без использования таких средств с
          персональными данными, включая сбор, запись, систематизацию,
          накопление, хранение, уточнение (обновление, изменение), извлечение,
          использование, передачу (распространение, предоставление, доступ),
          обезличивание, блокирование, удаление, уничтожение персональных данных
          с целью выполнения Исполнителем своих обязательств принятых по
          условиям настоящего Договора, иных обязательств, предусмотренных
          Договором, а также с целью выполнения требований нормативных актов по
          противодействию легализации денежных средств, полученных преступным
          путем и иных нормативных актов. Срок использования предоставленных
          Заказчиком персональных данных - бессрочно. Заказчик также дает свое
          согласие на обработку и использование Исполнителем предоставленной им
          информации и (или) его персональных данных с целью осуществления по
          указанному Заказчиком контактному телефону и (или) контактному
          электронному адресу информационной рассылки о мероприятиях Исполнителя
          и/или рекламной рассылки об иных услугах Исполнителя и/или партнера
          Исполнителя. Согласие на получение рассылки считается предоставленным
          бессрочно до получения Исполнителем письменного уведомления по
          электронной почте Исполнителя об отказе от получения рассылок.
          Заказчик также дает свое согласие на передачу, в целях осуществления
          действий Исполнителем, предусмотренных настоящим пунктом,
          предоставленной им информации и (или) его персональных данных третьим
          лицам при наличии надлежаще заключенного между Исполнителем и такими
          третьими лицами договора.
        </p>
        <p>
          4.15. Использование информации и материалов допускается только в
          личных целях и для личного использования Заказчика.
        </p>
        <p>
          4.16. Курс представляет собой совокупность отдельных услуг (уроков).
          Оказание и приемка каждой отдельной услуги (урока) происходит отдельно
          и не зависит от оказания и приемки иных услуг Заказчиком. Переход к
          изучению следующего урока подтверждает оказание услуг в части прошлого
          урока Исполнителем и их приемку Заказчиком.
        </p>
        <p>5. ПРАВА И ОБЯЗАННОСТИ ИСПОЛНИТЕЛЯ</p>
        <p>
          5.1. Исполнитель обязуется предоставить Заказчику доступ к Курсу в
          дату старта Курса.
        </p>
        <p>
          5.2. Исполнитель обязуется оказывать оплаченные Заказчиком услуги
          надлежащим образом и в полном объеме в соответствии с условиями
          настоящей Оферты.
        </p>
        <p>
          5.3. Исполнитель обязуется оказывать услуги в соответствии с их
          описанием на Сайте.
        </p>
        <p>
          5.4. Исполнитель несет ответственность за хранение и обработку
          персональных данных Заказчика, обеспечивает конфиденциальность этих
          данных в процессе их обработки и использует их исключительно для
          качественного оказания Информационной услуги Заказчику.
        </p>
        <p>
          5.5. Исполнитель гарантирует предоставление Заказчику полной и
          достоверной информации об оказываемой услуге по его требованию.
        </p>
        <p>
          5.6. Исполнитель оставляет за собой право в любой момент изменять
          длительность Курса и условия настоящей Оферты в одностороннем порядке
          без предварительного уведомления Заказчика, публикуя указанные
          изменения на Сайте не позднее 23 часов 59 минут по московскому времени
          в день, предшествующий дню вступления в действие соответствующих
          изменений.
        </p>
        <p>
          5.7. Исполнитель вправе продлить сроки проведения тренинга, уведомив
          об этого Заказчика не позднее трех дней с момента принятия такого
          решения, на срок, не превышающий 30 календарных дней.
        </p>
        <p>
          5.8. Исполнитель вправе заблокировать учетную запись Заказчика в
          случае нарушения им правил Курса без возвращения внесенной платы.
        </p>
        <p>
          5.9. Исполнитель вправе проводить фото- и видеосъемку, использовать
          фотографии, видео (иные медиа-материалы) Заказчика, касающихся услуг
          или сделанных непосредственно в рамках оказания услуг.
          Медиа-материалы, сделанные Заказчиком или от его имени, могут
          использоваться только с письменного разрешения Исполнителя.
        </p>
        <p>
          5.10. Исполнитель имеет право изменять стоимость услуг, даты и время
          проведения Курса, а также иные условия проведения Курса и условия
          настоящей Оферты. Исполнитель уведомляет Заказчика об указанных
          изменениях путем размещения информации на сайте Исполнителя по адресу
          https://www.guidedao.xyz/ и при этом Заказчик обязан самостоятельно
          знакомиться с указанными изменениями. Уведомление об изменении времени
          и даты проведения тренинга, помимо размещения информации по
          вышеуказанному адресу, может быть направлено Заказчику не позднее, чем
          за 5 часов до мероприятия путем направления соответствующего письма на
          контактный e-mail или посредством телефонного звонка по указанному
          Заказчиком контактному номеру телефона. Уведомление об изменении иных
          условий дополнительно размещается на сайте.
        </p>
        <p>
          5.11. Не приступать к оказанию услуг либо приостановить оказание при
          наличии любого из следующих оснований:
        </p>
        <p>
          5.11.1. нарушения Заказчиком сроков и иных условий оплаты услуг по
          настоящей Оферте;
        </p>
        <p>
          5.11.2. предоставления неполной и (или) недостоверной информации о
          Заказчике, необходимой для оказания услуг.
        </p>
        <p>
          5.12. Исполнитель вправе делать рассылки, в том числе рекламные, по
          всем зарегистрированным для участия в Курсе пользователям через:
          e-mail, социальные сети, смс, а также автоматические звонки.
          Отписаться от рассылок пользователь может в любое время, перейдя по
          ссылке в письме.
        </p>
        <p>
          5.13. Исполнитель вправе привлекать к оказанию Услуг третьих лиц без
          предварительного получения на то согласия Заказчика.
        </p>
        <p>
          5.14. Исполнитель не несет ответственности за невозможность
          предоставления услуг Заказчику по причинам, связанным с нарушением
          работы Интернет-канала, оборудования или программного обеспечения со
          стороны Заказчика, а также по любым другим причинам, препятствующим
          получению Заказчиком услуг, возникшим по вине Заказчика.
        </p>
        <p>
          5.15. Исполнитель не несет ответственности за действия банков,
          электронных платежных систем, обеспечивающих оплату и возвраты
          денежных средств при исполнении настоящей Оферты.
        </p>
        <p>6. ПРАВА И ОБЯЗАННОСТИ ЗАКАЗЧИКА</p>
        <p>Заказчик обязуется:</p>
        <p>
          6.1. Предоставлять достоверную информацию о себе, необходимую для
          заполнения заявки (в том числе ФИО, контакты для связи телефонной и
          электронной почты и т.п.). В случае если условием допуска к участию в
          Курсе является прохождение соответствующего собеседования, либо
          анкетирования, и Заказчик предоставляет Исполнителю недостоверную
          информацию о себе и своем бизнесе, а также предоставляет другие
          недостоверные данные по вопросам собеседования и/или анкетирования,
          Исполнитель вправе отказать Заказчику в оказании услуг в любое время с
          даты обнаружения недостоверности предоставленной информации.
        </p>
        <p>
          6.2. Не воспроизводить, не повторять, не копировать, не продавать, а
          также не использовать в каких бы то ни было целях (в том числе в
          коммерческих) информацию и материалы, ставшие ему доступными в связи с
          оказанием услуг, за исключением их личного использования.
        </p>
        <p>
          6.3. Поддерживать в исправном техническом состоянии оборудование и
          каналы связи, обеспечивающие ему доступ к Сайту. Исполнитель не несет
          ответственности за непредоставление (некачественное предоставление)
          услуг по причинам, не зависящим от Исполнителя.
        </p>
        <p>
          6.4. Самостоятельно и своевременно знакомится с актуальной редакцией
          Оферты по адресу https://www.guidedao.xyz/oferta
        </p>
        <p>
          6.5. Оплатить Услуги на условиях и по стоимости, действующих на момент
          оплаты.
        </p>
        <p>
          6.6. Не допускать третьих лиц к использованию доступного Заказчику
          Курса. В случае обнаружения Исполнителем факта использования тренинга
          Заказчика третьими лицами, Исполнитель вправе запретить Заказчику
          доступ к уже оплаченному тренингу без возврата ранее оплаченных
          денежных средств, удержав денежные средства как штраф за нарушение
          Заказчиком условий Договора.
        </p>
        <p>
          6.7. Соблюдать исключительные и авторские права Исполнителя и иных
          третьих лиц.
        </p>
        <p>
          6.8. Незамедлительно уведомить Исполнителя об изменении своих
          персональных и контактных данных в письменной форме посредством
          контактного e-mail.
        </p>
        <p>
          6.9. Выполнять все правила участия в Курсе, отраженные в настоящей
          Оферте, озвученные спикером во время проведения Курса и иным способом
          ставшие известными Заказчику.
        </p>
        <p>
          6.10. Соблюдать во время проведения Курса порядок и дисциплину как при
          регистрации, так и при проведении Курса, не создавать своими
          действиями неудобства для других Заказчиков, а также не мешать
          процессу проведения Курса. При нарушении условий настоящего пункта
          Исполнитель оставляет за собой право не допустить Заказчика к участию
          в Курсе или удалить Заказчика с площадки, на которой проводится Курс,
          при этом денежные средства, выплаченные Заказчиком за Курс, не
          возвращаются и считаются неустойкой, подлежащей оплате Исполнителю в
          связи с нарушением Заказчиком принятых на себя обязательств.
        </p>
        <p>
          6.11. Заказчик, подавая заявку на участие, тем самым подтверждает свое
          согласие с порядком и условиями, определяющими оказание услуг, и
          обязуется им следовать, а также дает согласие на обработку
          персональных данных.
        </p>
        <p>
          6.12. Заказчик дает согласие на осуществление Оператором любых
          действий в отношении полученных персональных данных, которые могут
          понадобиться для сбора, систематизации, хранения, уточнения
          (обновления, изменения), обработки, распространения и т.п. с учетом
          действующего законодательства. Согласие на обработку персональных
          данных дается без ограничения срока, но может быть отозвано
          (отправление посредством официальной электронной почты
          соответствующего заявления с подписью).
        </p>
        <p>
          6.13. Предоставляя персональные данные, Заказчик подтверждает, что
          ознакомлен с правами и обязанностями, предусмотренными Федеральным
          законом № 152-ФЗ от 27.07.2006 «О персональных данных» и данным
          Договором.
        </p>
        <p>Заказчик вправе:</p>
        <p>
          6.14. Получать услуги в рамках выбранного и оплаченного им Тарифа в
          соответствии с условиями настоящего Договора.
        </p>
        <p>
          6.15. Принимать решения относительно необходимости совершения тех или
          иных действий Заказчиком, рекомендуемых Исполнителем в рамках оказания
          услуг по настоящему Договору.
        </p>
        <p>7. ОТВЕТСТВЕННОСТЬ СТОРОН И ПОРЯДОК ВОЗВРАТА ДЕНЕЖНЫХ СРЕДСТВ </p>
        <p>
          7.1. Исполнитель и Заказчик, принимая во внимание характер оказываемых
          услуг, обязуются в случае возникновения споров и разногласий,
          связанных с оказанием услуг, применять досудебный порядок
          урегулирования спора.
        </p>
        <p>
          7.2. В случае невозможности урегулирования спора в досудебном порядке,
          стороны вправе обратиться в суд по месту нахождения Исполнителя.
        </p>
        <p>
          7.3. За неисполнение либо ненадлежащее исполнение обязательств по
          настоящей Оферте, стороны несут ответственность в соответствии с
          законодательством Российской Федерации.
        </p>
        <p>
          7.4. Прием к рассмотрению претензий Заказчика с требованием о возврате
          денежных средств прекращается последним днем оказания услуг, если не
          указано другое, что безоговорочно принимается сторонами.
        </p>
        <p>
          7.5. Возврат денег осуществляется в соответствии с п.7.9 настоящей
          оферты. Иной способ продления гарантированного срока возврата средств
          возможен и только на основании индивидуальной договоренности между
          сторонами.
        </p>
        <p>
          7.6. В случае совершения платежа с помощью банковской карты, Заказчику
          рекомендуется использовать банковскую карту, выпущенную на имя
          Заказчика. В случае осуществления возврата оплаченных денежных
          средств, возврат производится по тем же реквизитам, по которым был
          получен платеж, и на основании личного заявления лица, на чье имя была
          выпущена банковская карта. Оплата не принимается при обнаружении
          нарушения Заказчиком условий платежа, установленных настоящим
          Договором и законодательством Российской Федерации.
        </p>
        <p>
          7.7. Заказчик вправе отказаться от заказанных услуг Исполнителя в
          любое время до момента оказания Услуги. Услуга считается оказанной с
          момента предоставления доступа к материалам курса на{" "}
          <a href="https://learn.guidedao.xyz" target="_blank">
            https://learn.guide.xyz
          </a>{" "}
          и предоставления ссылки для доступа в Discord, посредством отправки по
          e-mail.
        </p>
        <p>
          7.8. В случае отказа Заказчика от услуг Исполнителя, уплаченная
          Заказчиком сумма за Услугу подлежит возврату Заказчику за вычетом
          понесенных Исполнителем до момента возврата расходов и комиссий
          банков. Возврат осуществляется в течение 10 календарных дней с момента
          предъявления соответствующего требования.
        </p>
        <p>
          7.9. В случае отказа Заказчика от услуг Исполнителя после частичного
          оказания услуг, суммы, поступившие в счет оплаты, возвращаются
          Заказчику за вычетом стоимости уже оказанных Исполнителем услуг на
          момент получения от Заказчика требования о возврате и комиссий банков.
          Стоимость отдельных видео уроков и онлайн сессий, входящих в состав
          курса, определяется по формуле: стоимость курса согласно тарифу /
          количество уроков и онлайн сессий, предусмотренных тарифом.
        </p>
        <p>
          7.10. Оказание Исполнителем услуг по проверке домашних заданий не
          влияет на стоимость отдельного видео урока или онлайн сессии, если
          домашнее задание не выполнялось Заказчиком.
        </p>
        <p>
          7.11. Все претензии по качеству оказываемой Информационной услуги
          должны направляться Заказчиком в адрес Исполнителя посредством подачи
          заявки на электронную почту yo@guidedao.xyz. Срок рассмотрения
          претензии(ий) Заказчика Исполнителем составляет 10 (десять)
          календарных дней (в том числе претензий, содержащих требование о
          возврате денежных средств) с момента поступления претензии в адрес
          Исполнителя.
        </p>
        <p>
          7.12. В случае принятия решения Исполнителем о возврате денежных
          средств, Денежные средства возвращаются Заказчику путем их зачисления
          на лицевой счет Заказчика в российском банке,
        </p>
        <p>
          7.13. Все возвраты денежных средств осуществляются при условии
          направления Заказчиком в адрес Исполнителя заявления по форме
          Исполнителя, которое будет выслано Заказчику письмом по электронной
          почте. Сторонами безоговорочно принимается, что окончательное решение
          о способе возврата денежных средств остается в каждом конкретном
          случае на усмотрение Исполнителя. В случае возврата денежных средств
          на счет Заказчика в российском банке или на счет Заказчика в платежной
          системе, заполненное заявление на возврат денежных средств с подписью
          Заказчика в сканированном электронном виде высылается по электронной
          почте Исполнителю (допускаются следующие форматы файла: gif, jpeg,
          pdf). Заявление на возврат Денежных средств должно содержать в
          обязательном порядке сведения о счете Заказчика, коммерческой
          организации (банке), где хранится счет, ее адресе. В случае отсутствия
          в заявлении необходимых сведений, требуемых для осуществления возврата
          денежных средств, Исполнитель не гарантирует сроков, указанных в п.
          7.11.
        </p>
        <p>
          7.14. Денежные средства зачисляются на счет в платежной системе
          Заказчика в течение 10 (десяти) рабочих дней с момента получения
          Исполнителем подписанного и сканированного заявления Заказчика.
          Денежные средства зачисляются на счет в российском банке, указанный
          Заказчиком, в течение 15 (пятнадцати) рабочих дней с момента получения
          Исполнителем подписанного и сканированного заявления Заказчика.
          Финансовый документ, подтверждающий внесение денежных средств
          Исполнителем на счет Заказчика, является доказательством исполнения
          Исполнителем обязанности по возврату денежных средств Заказчику, что
          безоговорочно принимается сторонами.
        </p>
        <p>
          7.15. Стороны освобождаются от ответственности за неисполнение или
          ненадлежащее исполнение обязательств, вытекающих из настоящей оферты,
          если причиной неисполнения (ненадлежащего исполнения) являются
          обстоятельства непреодолимой силы, к которым, среди прочих, относятся
          стихийные бедствия, пожары, техногенные аварии и катастрофы, аварии на
          инженерных сооружениях и коммуникациях, массовые беспорядки, военные
          действия, террористические акты, бунты, гражданские волнения,
          забастовки, эпидемии, вызванные распространением вируса, нормативные
          акты органов государственной власти и местного самоуправления,
          препятствующие исполнению Сторонами своих обязательств по
          Договору-оферте, то есть чрезвычайные и непреодолимые при данных
          условиях обстоятельства, независящие от воли Сторон, наступившие после
          подписания Договора-оферты.
        </p>
        <p>
          7.16. В случае переноса срока оказания услуг действие настоящей оферты
          продлевается на срок, равный сроку переноса. При отмене услуги
          договорные обязательства Сторон прекращаются. В случае отмены услуги
          по вине Исполнителя, Исполнитель обязуется возместить Заказчику
          уплаченные им денежные средства в полном размере.
        </p>
        <p>8. ГАРАНТИИ КАЧЕСТВА ИНФОРМАЦИОННОЙ УСЛУГИ</p>
        <p>
          8.1. Заказчик, принимая условия настоящей Оферты, принимает на себя
          все риски, связанные с использованием умений и навыков, полученных
          Заказчиком в ходе оказания услуг, Исполнитель не несет ответственности
          за достижение каких-либо результатов.
        </p>
        <p>
          8.1.2. Исполнитель не несет ответственности за несоответствие
          предоставленной услуги ожиданиям Заказчика и/или за его субъективную
          оценку, такое несоответствие ожиданиям и/ или отрицательная
          субъективная оценка не являются основаниями считать услуги оказанными
          некачественно, или не в согласованном объеме.
        </p>
        <p>
          8.2. Исполнитель в ходе оказания услуг вправе требовать у Заказчика
          выполнения «домашних заданий» — определенных действий Заказчика,
          планируемых и поручаемых Исполнителем, позволяющих Исполнителю
          проверять и убеждаться в усвоении Заказчиком информации, полученной в
          ходе проведения тренинга, приобретении им опыта решения конкретных
          задач в рамках темы тренинга, а также для иных целей Исполнителя.
          «Домашние задания» направляются Заказчику посредством электронной
          связи: на электронную почту либо иным способом, оговариваемым отдельно
          в каждом случае.
        </p>
        <p>9. СРОК ДЕЙСТВИЯ ОФЕРТЫ. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</p>
        <p>
          9.1. Настоящая оферта действует с даты ее заключения, которой
          считается дата акцепта Оферты Заказчиком, и до даты окончания оказания
          Исполнителем конкретной услуги.
        </p>
        <p>
          9.2. Оформленная Заказчиком Заявка, которая заполняется на сайте
          Исполнителя, является неотъемлемой частью настоящей оферты.
        </p>
        <p>
          9.3. Заказчик подтверждает, что все условия настоящей оферты ему ясны,
          и он принимает их безусловно и в полном объеме.
        </p>
        <p>
          9.4. Настоящая оферта действует на территории всех стран мира, и в
          интерактивной информационной сети Интернет.
        </p>
        <p>
          9.5. В случае, если после оказания услуг Заказчик предоставляет
          Исполнителю отзыв в текстовой форме, в форме видеозаписи или в форме
          изображения, Исполнитель имеет право использовать данный отзыв, в том
          числе в коммерческих целях (например, для рекламы и продвижения) без
          внесения платы за это Заказчику.
        </p>
        <p>10. РЕКВИЗИТЫ ИСПОЛНИТЕЛЯ</p>
        <p>
          ООО "МОСКОУ КОДИНГ СКУЛ" ИНН 7725262648, ОГРН 1157746115438 Юр.адрес:
          115054, г. Москва, ул. Дубинская, д. 57, стр. 1, э/пом/к/оф 2 пом IК
          7Б О 12Б 115569, г. Москва, «Москоу Кодинг Скул», а/я 6 р/с
          40702810602620000744 АО "АЛЬФА-БАНК" г Москва к/с 30101810200000000593
          БИК 044525593 Телефон: +7 (495) 150-37-60 Адрес электронной почты:
          yo@guidedao.xyz.
        </p>
      </div>
    </>
  );
};
export default Oferta;
